export const GET_PRODUCT_BRAND_AND_CATEGORY_DATA =
    'MORE:GET_PRODUCT_BRAND_AND_CATEGORY_DATA';
export const GET_PRODUCT_BRAND_AND_CATEGORY_DATA_SUCCESS =
    'MORE:GET_PRODUCT_BRAND_AND_CATEGORY_DATA_SUCCESS';
export const GET_PRODUCT_BRAND_AND_CATEGORY_DATA_FAILURE =
    'MORE:GET_PRODUCT_BRAND_AND_CATEGORY_DATA_FAILURE';

export const GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY =
    'MORE:GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY';
export const GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY_SUCCESS =
    'GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY_SUCCESS';
export const GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY_FAILURE =
    'GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY_FAILURE';

export const SET_PRODUCTSGUIDE = 'SET_PRODUCTSGUIDE';
export const CLEAR_PRODUCTS_GUIDE = 'CLEAR_PRODUCTS_GUIDE';
export const VALIDATE_PRODUCTS = 'VALIDATE_PRODUCTS';
export const VALIDATE_PRODUCTS_SUCCESS = 'VALIDATE_PRODUCTS_SUCCESS';
export const VALIDATE_PRODUCTS_FAILURE = 'VALIDATE_PRODUCTS_FAILURE';
export const CLEAR_VALIDATED_PRODUCTS = 'CLEAR_VALIDATED_PRODUCTS';
export const SET_CART_DATA = 'SET_CART_DATA';
export const SET_PRODUCTGUIDE_FILTER_OPEN = 'SET_PRODUCTGUIDE_FILTER_OPEN';
export const SET_SELECTED_CATEGORY = 'SET_SELECTED_CATEGORY';

export const SET_APPLIED_FILTER = 'SET_APPLIED_FILTER';
export const MORE_GET_PRODUCTS = 'MORE_GET_PRODUCTS';
export const MORE_GET_PRODUCTS_SUCCESS = 'MORE_GET_PRODUCTS_SUCCESS';
export const MORE_GET_PRODUCTS_FAILURE = 'MORE_GET_PRODUCTS_FAILURE';
export const SET_SELECTED_CATEGORY_FILTER = 'SET_SELECTED_CATEGORY_FILTER';
export const SET_SELECTED_SUB = 'SET_SELECTED_SUB';

export const GET_PRODUCT_CATOGORY_LIST = 'GET_PRODUCT_CATOGORY_LIST';
export const GET_PRODUCT_CATOGORY_LIST_SUCCESS =
    'GET_PRODUCT_CATOGORY_LIST_SUCCESS';
export const GET_PRODUCT_CATOGORY_LIST_FAILURE =
    'GET_PRODUCT_CATOGORY_LIST_FAILURE';
export const SET_SEARCHPARAM_PRODUCT_GUIDE = 'SET_SEARCHPARAM_PRODUCT_GUIDE';
export const SET_APPLIED_BRAND_VALUES = 'SET_APPLIED_BRAND_VALUES';
export const SET_PAGE_NUM = 'SET_PAGE_NUM';
export const SET_SUB_CATEGORY = 'SET_SUB_CATEGORY';

export const GLOBAL_FILTER_OPEN = 'GLOBAL_FILTER_OPEN';
export const CLOSE_SHOW_PAGE = 'CLOSE_SHOW_PAGE';

export const SET_APPLIED_SUBCATEGORY = 'SET_APPLIED_APPROACH';
export const UPDATE_SUBCATEGORY_REFINE_DATA = 'UPDATE_SUBCATEGORY_REFINE_DATA';

export const SET_APPLIED_BRANDS = 'SET_APPLIED_BRANDS';
export const UPDATE_BRANDS_DATA = 'UPDATE_BRANDS_DATA';
export const SET_PRODUCT_GUIDE_VALUES = 'SET_PRODUCT_GUIDE_VALUES';

export const SET_SELECTED_TAB = 'SET_SELECTED_TAB';
export const SET_SORT_CODE = 'SET_SORT_CODE';
export const CLEAR_PRODUCTS_GUIDE_DATA = 'CLEAR_PRODUCTS_GUIDE_DATA';
